/**
 * ex.
 * 基本のボタン
 * <base-button text="サンプル" on-click="onClick()"></base-button>
 *
 * アイコン付きボタン
 * <base-button text="アイコン付きボタン" type="primary" size="l" show-icon="true" on-click="addFunction()" icon-name="checkmark-outline"></base-button>
 */
angular.module('inspinia').directive('baseButton', () => {
  return {
    restrict: 'E',
    scope: {
      text: '@',
      type: '@',
      transparent: '=?',
      ngDisabled: '=?',
      size: '@',
      onClick: '&',
      iconName: '@',
      showIcon: '=?',
      baseButtonClasses: '&',
    },
    templateUrl: `/manage/src/view/directive/button/base_button.html?${new Date().getTime()}`,
    link($scope) {
      $scope.showIcon = $scope.showIcon || false;
      $scope.ngDisabled = $scope.ngDisabled || false;
      $scope.transparent = $scope.transparent || false;

      const buttonSize = ['s', 'r', 'l'];
      $scope.size = $scope.size || 'r';
      if (buttonSize.indexOf($scope.size) === -1) {
        throw new Error('button size is s,r,l');
      }

      const buttonType = ['secondary', 'primary', 'alert'];
      $scope.type = $scope.type || 'primary';
      if (buttonType.indexOf($scope.type) === -1) {
        throw new Error('button type is secondary, primary, alert');
      }
      if (!$scope.text) {
        throw new Error('button text is required');
      }

      $scope.onClickBaseButton = () => {
        // 無効の場合、クリックイベントは発火させない
        if (!$scope.ngDisabled) $scope.onClick();
      };

      /** CSSのクラス名を返す */
      $scope.baseButtonClasses = () => {
        const buttonClasses = {};
        if ($scope.transparent) {
          buttonClasses[`anglrC-buttonTransparent`] = true;
          if ($scope.type) {
            buttonClasses[`anglrC-buttonTransparent--${$scope.type}`] = true;
            buttonClasses[`anglrC-buttonTransparent--${$scope.size}`] = true;
          }
          if ($scope.ngDisabled) {
            buttonClasses['anglrC-buttonTransparent--disabled'] = true;
          }
        } else {
          buttonClasses[`anglrC-button`] = true;
          buttonClasses[`anglrC-button--${$scope.size}`] = true;
          if ($scope.ngDisabled) {
            buttonClasses['anglrC-button--disabled'] = true;
          } else {
            buttonClasses[`anglrC-button--${$scope.type}`] = true;
          }
        }

        return buttonClasses;
      };
    },
  };
});
